import React from 'react'
import styles from './styles'
import { Typography } from '@material-ui/core'
import LineTo from 'react-lineto';
import withStyles from '@material-ui/core/styles/withStyles'

const Labels = (props) => {

  const {
    classes,
    canwidth
  } = props
  console.log("canwidth", canwidth)

  // const setP2Label = () => {
  //   let answerCondition = answer.includes('shifts left')

  //   if (answer.includes('Demand'))
  //     answerCondition = !answerCondition

  //   if (answerCondition)
  //     if (isMobile)
  //       return "44px"
  //     else if (isEmulator)
  //       return '58px'
  //     else
  //       return '95px'
  //   else
  //     if (isMobile)
  //       return "78px"
  //     else if (isEmulator)
  //       return '102px'
  //     else
  //       return '165px'
  // }

  // const setQ2Label = () => {
  //   if (answer.includes('shifts left'))
  //     if (isMobile)
  //       return "76px"
  //     else if (isEmulator)
  //       return '112px'
  //     else
  //       return '173px'
  //   else
  //     if (isMobile)
  //       return "115px"
  //     else if (isEmulator)
  //       return '165px'
  //     else
  //       return '250px'
  // }

  // const calcBorderWidth = () => {
  //   if (isMobile)
  //     return "3px"
  //   else
  //     return "4px"
  // }

  return (
    <span className="animate__animated animate__fadeIn">
      {/* <Typography className={classes.graphP1Lable}>P1</Typography>
      <Typography className={classes.graphP2Lable}>P2</Typography> */}
      {/* <Typography className={classes.graphQ1Lable}>Q1</Typography> */}
      <>
        <div
          className={'P1'}
          style={{
            position: 'absolute',
            top: 240,
            left: 45
          }}
        />
        <div
          className={'P2'}
          style={{ position: 'absolute', left: 45, top: 313 }}
        />

        <div
          style={{
            position: 'absolute',
            top: 240,
            // left: "50%",
            zIndex: 110,
            width: canwidth,
            background: 'red',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
          }}
        >
          <div className={'dotOriginP'} style={{ marginLeft: "5%" }}></div>
        </div>
        <div
          // className={'dotCorrectP'}
          style={{
            position: 'absolute',
            top: 313,
            // left: "10%",
            width: canwidth,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
          }}
        >
          <div className={'dotCorrectP'} style={{ marginLeft: "5%" }}></div>
        </div>


        <LineTo
          from="dotOriginP"
          to="P1"
          orientation='h'
          borderStyle='dashed'
          borderWidth={5}
          borderColor='#003e4c'
          fromAnchor='20%'delay={true}
          className="animate__animated animate__fadeIn"
        />
        <LineTo
          from="dotCorrectP"
          to="P2"
          orientation='h'
          borderStyle='dashed'
          borderWidth={5}
          borderColor='#003e4c'
          fromAnchor='20%'delay={true}
          className="animate__animated animate__fadeIn"
        />

        <div
          style={{
            position: 'absolute',
            top: 455,
            // zIndex: 110,
            width: canwidth,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'start',
          }}
        >
          <div className={'Q1'} style={{ marginLeft: "5%" }}></div>
        </div>

        {/* <div className={'Q1'} style={{ position: 'absolute', top: 455, left: 240 }} /> */}

        <LineTo
          from="dotOriginP"
          to="Q1"
          orientation='h'
          borderStyle='dashed'
          borderWidth={5}
          borderColor='#003e4c'
          fromAnchor='20%'delay={true}
          className="animate__animated animate__fadeIn"
        />
      </>
    </span>
  )
}

export default withStyles(styles)(Labels)
